import React from "react";
const ArrowDown = ({ ...r }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      fillRule="evenodd"
      viewBox="0 0 24 24"
      {...r}
    >
      <path
        fill="#272727"
        d="M12.364 12.95l4.243-4.243a1 1 0 011.414 1.414l-4.95 4.95a1 1 0 01-1.414 0l-4.95-4.95a1 1 0 111.414-1.414l4.243 4.243z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default ArrowDown;
